"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWebsiteSecondaryNavItems = void 0;
var _navConstants = require("../constants/navConstants");
/**
 * Used in web-preauth, web-wedding
 */

var parent = _navConstants.PrimaryNavIdentifier.WEBSITE;
var businessUnit = 'WEBSITE';
var getWebsiteSecondaryNavItems = exports.getWebsiteSecondaryNavItems = function getWebsiteSecondaryNavItems(userContext) {
  if (userContext && !userContext.has_website) {
    return [];
  }
  var manageWebsite = {
    id: _navConstants.SecondaryNavIdentifier.MANAGE,
    path: '/wedding/manage/website/manage',
    title: 'Manage website',
    parent: parent,
    businessUnit: businessUnit
  };
  var editWebsite = {
    id: _navConstants.SecondaryNavIdentifier.EDIT,
    path: '/wedding/manage/website/pages/home',
    title: 'Edit website',
    parent: parent,
    businessUnit: businessUnit
  };
  return [manageWebsite, editWebsite];
};